export enum NoteEditorComponentMode {
	Create,
	View,
	ViewAcknowledge,
}
